import React, { Component } from 'react';

export default class ModalDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
        }
    }
    
    render() {
        return(
            <>
                {
                    this.props.statusModal &&
                    <div className="modal fade show" id="deleteKelas" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.8)'}} tabindex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content"> 
                                <div className="modal-header alert-danger">
                                    <h4 className="modal-title">
                                        <li className="fa fa-trash"></li>&nbsp; Hapus
                                    </h4>
                                    <button type="button" className="close" data-dismiss="modal" onClick={() => this.props.onChange('isShowDelete', false)}>&times;</button>
                                </div>

                                <div className="modal-body">
                                    <h5>Apakah anda yakin menghapus data ini?</h5>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.props.onChange('isShowDelete', false)}>Batal</button>
                                    <button type="submit" className="btn btn-danger" onClick={this.props.eventSubmit}>Hapus</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}